import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {ActivatedRoute, Router} from "@angular/router";
import {FormControl} from "@angular/forms";

@Component({
    selector: 'db-product-actions-header',
    templateUrl: './product-actions-header.component.html',
    styleUrls: ['./product-actions-header.component.scss'],
    standalone: false
})
export class ProductActionsHeaderComponent implements OnInit {
  @Output('onSave') saveEmitter: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Output('onUpdate') updateEmitter: EventEmitter<void> = new EventEmitter<void>();
  @Output('onDiscard') discardEmitter: EventEmitter<void> = new EventEmitter<void>();
  @Input() isEdit = false;
  @Input() statusForm: FormControl;
  @Input() isPublished = false;
  @Input() productUrl;

  constructor(private _router: Router,
              private _activatedRoute: ActivatedRoute) {
  }

  ngOnInit() {
  }

  navigateBacK() {
    this._router.navigate(['.'], {relativeTo: this._activatedRoute.parent});
  }

}
